import { useMutation } from "@tanstack/react-query";

import { updateJobWithRethrow } from "src/api/projects";

export const useUpdateJob = () => {
  return useMutation({
    mutationFn: async (payload: $TSFixMe) => await updateJobWithRethrow(payload)
  });
};
